import { LogLevel } from "@azure/msal-browser";
/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const getMsalConfig = (company=null) => {
    return {
        auth: {
            clientId: company?.client_id || "4ef0a381-4642",
            authority: `https://login.microsoftonline.com/${company?.tenant_id || "976d477d-3232"}`,
            // redirectUri: company?.redirect_url || "https://gemm.iaautomation.com/",
            redirectUri: "http://localhost:3000",
        },
        cache: {
            cacheLocation: "sessionStorage",
            storeAuthStateInCookie: false,
        },
        system: {
            allowRedirectInIframe: true,
            loggerOptions: {
                loggerCallback: (level, message, containsPii) => {
                    if (!containsPii) console.log(`[MSAL-${level}]`, message);
                },
                logLevel: LogLevel.Info,
            },
        },
    };
};
/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const getLoginRequest = (company) => ({
    scopes: ["User.Read", "User.Read","Calendars.Read","Calendars.ReadWrite","User.Read.All"],
    // scopes: company?.scopes
    //     ? company.scopes.split(",").map((s) => s.trim())
    //     : ["User.Read"],
});
/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
    graphEventsEndpoint: "https://graph.microsoft.com/v1.0/me/events",
    graphUsers: "https://graph.microsoft.com/v1.0/users",
    grapCalendarView :"https://graph.microsoft.com/v1.0/me/calendarview"
};